import React, { useMemo } from 'react';
import { ReactFlow, Handle, Position, Background } from '@xyflow/react';
import '@xyflow/react/dist/style.css';

// Static architecture diagrams for the Docs page. Each spec is hand-laid on
// a unit grid (data/docsDiagrams.js); this just renders it with the same
// node styling as the live network topology (ah-flow-*). Read-only: nodes
// don't drag, scroll passes through to the page.

const UNIT_X = 200; // grid unit -> px
const UNIT_Y = 92;

function DocNode({ data }) {
  return (
    <div className={`ah-flow-node ah-docs-node ${data.tint ? `tint-${data.tint}` : ''}`} style={data.w ? { width: data.w } : undefined}>
      <Handle type="target" position={data.dir === 'h' ? Position.Left : Position.Top} className="ah-flow-handle" />
      {data.kind && <span className="ah-flow-conn ah-docs-kind">{data.kind}</span>}
      <div className="ah-flow-name">{data.label}</div>
      {data.sub && <div className="ah-flow-sub">{data.sub}</div>}
      <Handle type="source" position={data.dir === 'h' ? Position.Right : Position.Bottom} className="ah-flow-handle" />
    </div>
  );
}

const nodeTypes = { doc: DocNode };

export default function DocsDiagram({ spec }) {
  const { nodes, edges } = useMemo(() => {
    const dir = spec.dir || 'v';
    return {
      nodes: spec.nodes.map((n) => ({
        id: n.id,
        type: 'doc',
        position: { x: n.x * UNIT_X, y: n.y * UNIT_Y },
        data: { ...n, dir },
        draggable: false,
        connectable: false,
      })),
      edges: (spec.edges || []).map((e, i) => ({
        id: `e${i}`,
        source: e.from,
        target: e.to,
        label: e.label,
        animated: !!e.animated,
        style: e.dashed
          ? { strokeDasharray: '5 4', stroke: 'rgba(255,255,255,0.28)' }
          : { stroke: 'rgba(255,255,255,0.35)' },
        labelStyle: { fill: 'rgba(255,255,255,0.6)', fontSize: 10 },
        labelBgStyle: { fill: 'rgba(20,20,24,0.85)' },
        type: 'smoothstep',
      })),
    };
  }, [spec]);

  return (
    <div className="ah-flow-wrap ah-docs-flow" style={{ height: spec.height || 420 }}>
      <ReactFlow
        nodes={nodes}
        edges={edges}
        nodeTypes={nodeTypes}
        fitView
        fitViewOptions={{ padding: 0.12 }}
        nodesDraggable={false}
        nodesConnectable={false}
        elementsSelectable={false}
        zoomOnScroll={false}
        panOnScroll={false}
        preventScrolling={false}
        proOptions={{ hideAttribution: false }}
      >
        <Background gap={24} size={1} />
      </ReactFlow>
    </div>
  );
}
